import * as React from 'react';
const SvgJumpcloud = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    data-name="Layer 1"
    viewBox="0 0 176.19 86.68"
    {...props}
  >
    <path
      fill="#4cc2bf"
      d="M172.54 61.34c0 12.63-10.24 22.88-22.88 22.88h-6.3c-.66-7.61-8.51-14.1-19.63-17.1 4.19-4.14 6.54-10.12 5.74-16.64-1.11-8.97-8.42-16.19-17.41-17.19-11.99-1.34-22.13 8.01-22.13 19.72 0 5.52 2.26 10.51 5.89 14.11-5.9 1.6-10.88 4.17-14.36 7.37-2.4-1.41-5.22-2.57-8.33-3.41 3.57-3.53 5.58-8.64 4.89-14.19-.95-7.65-7.18-13.8-14.85-14.66-10.22-1.14-18.87 6.83-18.87 16.82 0 4.71 1.92 8.96 5.03 12.03-8.77 2.37-15.16 7.28-16.52 13.15h-6.3c-12.63 0-22.88-10.24-22.88-22.88s10.24-22.88 22.88-22.88c3.01 0 5.88.59 8.51 1.64 3.58-7.96 11.57-13.5 20.87-13.5.56 0 1.11.03 1.66.07C60.16 12.89 72.27 2.47 86.81 2.47c10.85 0 20.34 5.8 25.55 14.46 2.24-.68 4.61-1.05 7.07-1.05 13.11 0 23.79 10.39 24.26 23.38a22.9 22.9 0 0 1 5.95-.79c12.63 0 22.88 10.24 22.88 22.88z"
    />
  </svg>
);
export default SvgJumpcloud;
